<form [formGroup]="frmGroup">
  <label *ngIf="fieldInfo.showLabel" [fieldInfo]="fieldInfo" acForLable>
    {{ fieldInfo.label
    }}<span class="required-star" *ngIf="fieldInfo.required && fieldInfo.label"
      >*</span
    >
  </label>

  <span
    *ngIf="InputConfig?.numericConfig?.type == 'currency'; else numberTemplate"
  >
    <hcc-custom-validation [validations]="fieldInfo.validations">
      <input
        HccMyCurrency
        type="text"
        [value]="value"
        (input)="change($event.target.value)"
        (blur)="touch()"
        [control]="control"
        [formGroup]="frmGroup"
        class="form-control"
        [formControlName]="control"
        inputValidateRef
        acInputNumber
        [fieldInfo]="fieldInfo"
        [readOnly]="InputConfig?.isDisabled"
      />
    </hcc-custom-validation>
  </span>

  <ng-template #numberTemplate>
    <span
      *ngIf="InputConfig?.numericConfig?.type == 'phone'; else numericField"
    >
      <hcc-custom-validation [validations]="fieldInfo.validations">
        <input
          HccPhone
          type="text"
          [value]="value"
          (input)="change($event.target.value)"
          (blur)="touch()"
          [control]="control"
          [formGroup]="frmGroup"
          [maxlength]="getMaxLength(fieldInfo.maxChar)"
          class="form-control"
          [formControlName]="control"
          inputValidateRef
          acInputNumber
          [fieldInfo]="fieldInfo"
          [readOnly]="InputConfig?.isDisabled"
        />
      </hcc-custom-validation>
    </span>

    <ng-template #numericField>
      <hcc-custom-validation [validations]="fieldInfo.validations">
        <input
          type="text"
          [value]="value"
          (input)="change($event.target.value)"
          (blur)="touch()"
          [control]="control"
          [formGroup]="frmGroup"
          class="form-control"
          [formControlName]="control"
          inputValidateRef
          acInputNumber
          [fieldInfo]="fieldInfo"
          [readOnly]="InputConfig?.isDisabled"
        />
      </hcc-custom-validation>
    </ng-template>
  </ng-template>
</form>
